window.Products.HomeDecor.StainlessSteelTumbler = function () {}
window.Products.HomeDecor.StainlessSteelTumbler.inherits(window.Products.HomeDecor.HomeDecor)